export default {"src":"/_next/static/media/PAGP.fbabcc96.svg","height":18,"width":18};